import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  TextField,
  Grid,
  Button,
  
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useMediaQuery,
  Alert,
  Snackbar, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BuildIcon from '@mui/icons-material/Build';
import CategoryIcon from '@mui/icons-material/Category';
import HeaderMenu from '../Header/HeaderMenu';
import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
const emptyRow = {
  date: '',
  name: '',
  description: '',
  amount: '',
  billNo: '',
  id: null,
  isSaved: false,
  isEditing: true,
};

const TabPanel = ({ value, index, children }) =>
  value === index ? <Box mt={4}>{children}</Box> : null;

const DailyHostelExpense = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [tab, setTab] = useState(0);
  const [filter, setFilter] = useState({ month: '' });
  const [hostelList, setHostelList] = useState([]);
  const [pendingHostelFilter, setPendingHostelFilter] = useState('');
  const [searchTriggered, setSearchTriggered] = useState(false);
  
const [dataLoaded, setDataLoaded] = useState(false);
  const [data, setData] = useState({
  purchase: [],
  staff: [],
  maintenance: [],
  misc: [],
});

  /* ================= Fetch Hostels ================= */

  useEffect(() => {
    axiosApi
      .post('/hostel/getHostelName', {})
      .then((response) => {
        const list = Array.isArray(response.data)
          ? response.data
          : response.data?.hostels || [];
        setHostelList(list.map(([id, name]) => ({ id, hostelName: name })));
      })
      .catch((err) => console.error(err));
  }, []);

const canAddExpense = checkPermission("Hostel", "Expense", "ADDEXP");
const canEditExpense = checkPermission("Hostel", "Expense", "EDITEXP");
const canDeleteExpense = checkPermission("Hostel", "Expense", "DELETEXP");
const canSaveExpense = checkPermission("Hostel", "Expense", "SAVEEXP");
const [errorMsg, setErrorMsg] = useState("");
const [deleteConfirm, setDeleteConfirm] = useState({
  open: false,
  type: "",
  index: null,
});
const [banner, setBanner] = useState({
  open: false,
  message: "",
  severity: "success",
});

  /* ================= Helpers ================= */

  const handleChange = (type, index, field, value) => {
    const updated = [...data[type]];
    updated[index][field] = value;
    setData({ ...data, [type]: updated });
  };

const addRow = (type) => {
  const hasEditing = data[type].some((r) => r.isEditing);

  if (hasEditing) {
    setBanner({
      open: true,
      message: "Please save current row before adding new one",
      severity: "error",
    });
    return;
  }

  setData({
    ...data,
    [type]: [...data[type], { ...emptyRow }],
  });
};

  

  const totalAmount = (type) =>
    data[type].reduce((sum, r) => sum + Number(r.amount || 0), 0);

  /* ================= API ================= */

 const handleSearch = async () => {
  if (!filter.month) return;

  const selectedHostel = hostelList.find(
    (h) => h.hostelName === pendingHostelFilter
  );

  try {
    const response = await axiosApi.post(
      "/hostelExpense/getHostelExpense",
      {
        month: filter.month,
        hostelIds: selectedHostel ? [selectedHostel.id] : [],
      }
    );

    if (Array.isArray(response.data)) {

      const formatted = {
        purchase: [],
        staff: [],
        maintenance: [],
        misc: []
      };

      response.data.forEach((exp) => {

        if (!exp.hostelExpenseItemDTOs) return;

     const rows = exp.hostelExpenseItemDTOs.map((item) => ({
  id: item.id,   // ✅ REQUIRED (this is what delete needs)
  date: item.expenseDate?.split("T")[0] || "",
  name: item.partyName || "",
  description: item.description || "",
  billNo: item.billNo || "",
  amount: item.expenseAmount || "",
  isSaved: true,
  isEditing: false,
}));

        const type = exp.expenseType?.toLowerCase();

        if (type === "purchase") formatted.purchase = rows;
        if (type === "staff") formatted.staff = rows;
        if (type === "maintenance") formatted.maintenance = rows;
        if (type === "misc") formatted.misc = rows;
      });

      setData({
  purchase: formatted.purchase || [],
  staff: formatted.staff || [],
  maintenance: formatted.maintenance || [],
  misc: formatted.misc || [],
});

setDataLoaded(true);

      
    }

  } catch (err) {
    console.error(err);
  }
};
const handleSaveRow = async (type, index) => {
  const row = data[type][index];

  if (!row.date || !row.name || !row.amount) {
  setBanner({
    open: true,
    message: "Date, Name & Amount are required",
    severity: "error",
  });
  return;
}


  const selectedHostel = hostelList.find(
    (h) => h.hostelName === pendingHostelFilter
  );

  try {
    const payload = {
      hostelExpenseDTO: {
        hostelId: selectedHostel.id,
        month: filter.month,
        expenseType: type.toUpperCase(),
        hostelExpenseItemDTOs: [
          {
			id: row.id,
            expenseDate: row.date,
            partyName: row.name,
            description: row.description,
            billNo: row.billNo,
            expenseAmount: Number(row.amount),
          },
        ],
      },
    };

    await axiosApi.post("/hostelExpense/updateHostelExpense", payload);

    const updated = [...data[type]];
    updated[index].isSaved = true;
    updated[index].isEditing = false;

    setData({ ...data, [type]: updated });

    setBanner({
      open: true,
      message: "Saved successfully",
      severity: "success",
    });

  } catch (err) {
    setBanner({
      open: true,
      message: "Save failed",
      severity: "error",
    });
  }
};
const handleDeleteRow = async (type, index) => {
  const row = data[type][index];

  console.log("DELETE ROW:", row);

  try {
    // ✅ Call API only if row exists in DB
    if (row.id) {
      await axiosApi.post("/hostelExpense/deleteHostelExpense", {
        hostelExpenseItemIds: [row.id], // ✅ CORRECT FIELD
      });
    }

    // ✅ Always remove from UI
    const updated = data[type].filter((_, i) => i !== index);
    setData({ ...data, [type]: updated });

    setBanner({
      open: true,
      message: "Deleted successfully",
      severity: "success",
    });

  } catch (err) {
    console.error("DELETE ERROR:", err);

    setBanner({
      open: true,
      message: "Delete failed",
      severity: "error",
    });
  }
};



  /* ================= Row Renderer ================= */

 const renderRows = (type, label, showBillNo) => {

  // 🚫 Do not show rows before search
  if (!dataLoaded) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        Please select Property & Month and click Search to load expenses.
      </Alert>
    );
  }

  return (
    <>
      {/* If no data after search */}
      {data[type].length === 0 && (
        <Alert severity="info" sx={{ mb: 2 }}>
          No expenses found. Click "Add New Item" to create.
        </Alert>
      )}

      {data[type].map((row, index) => (
        <Paper
          key={index}
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            background: '#f9fbff',
            border: '1px solid #e3eaf3',
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} md={2}>
              <TextField
                type="date"
                fullWidth
                size="medium"
                label="Bill Date"
                disabled={!row.isEditing || !canEditExpense}
                InputLabelProps={{ shrink: true }}
                value={row.date}
				
                onChange={(e) =>
                  handleChange(type, index, 'date', e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                size="medium"
                label={label}
                
                value={row.name}
				disabled={!row.isEditing || !canEditExpense}
                onChange={(e) =>
                  handleChange(type, index, 'name', e.target.value)
                }
              />
            </Grid>

            {showBillNo && (
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  size="medium"
                  label="Bill No"
                  
                  value={row.billNo}
				  disabled={!row.isEditing || !canEditExpense}
                  onChange={(e) =>
                    handleChange(type, index, 'billNo', e.target.value)
                  }
                />
              </Grid>
            )}

            <Grid item xs={12} md={showBillNo ? 3 : 4}>
              <TextField
                fullWidth
                size="medium"
                label="Description"
                
                value={row.description}
				disabled={!row.isEditing || !canEditExpense}
                onChange={(e) =>
                  handleChange(type, index, 'description', e.target.value)
                }
              />
            </Grid>

            <Grid item xs={10} sm={1.5}>
              <TextField
  fullWidth
  size="medium"
  type="number"
  label="Amount"
  disabled={!row.isEditing || !canEditExpense}
  value={row.amount}
  onChange={(e) =>
    handleChange(type, index, 'amount', e.target.value)
  }
/>
            </Grid>

            
          </Grid>
<Stack direction="row" spacing={1} sx={{ mt: 2 }}>
  <Button
    size="small"
    variant="contained"
    disabled={!row.isEditing || !canSaveExpense}
    onClick={() => handleSaveRow(type, index)}
  >
    {row.isSaved ? "Saved" : "Save"}
  </Button>

  <Button
    size="small"
    variant="outlined"
    disabled={
      row.isEditing || data[type].some((r, i) => i !== index && r.isEditing)
    }
    onClick={() => {
      const updated = [...data[type]];
      updated[index].isEditing = true;
      updated[index].isSaved = false;
      setData({ ...data, [type]: updated });
    }}
  >
    Edit
  </Button>

  <Button
    size="small"
    variant="outlined"
    color="error"
    disabled={
      !canDeleteExpense || data[type].some((r) => r.isEditing)
    }
    onClick={() =>
      setDeleteConfirm({
        open: true,
        type,
        index,
      })
    }
  >
    Delete
  </Button>
</Stack>

        </Paper>
		
		
      ))}

      {/* Add Row Button */}
     <Button
  fullWidth
  disabled={
    !canAddExpense ||
    !searchTriggered ||
    data[type].some((r) => !r.isSaved)
  }
  variant="outlined"
  startIcon={<AddIcon />}
  sx={{ mt: 2 }}
  onClick={() => addRow(type)}
>
  Add New Item
</Button>



      {/* Bottom Action Section */}
<Box
  sx={{
    mt: 4,
    pt: 3,
    borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: isMobile ? "column" : "row",
    gap: 2,
  }}
>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 700,
      color: "#1976d2"
    }}
  >
    Total: ₹ {totalAmount(type).toLocaleString()}
  </Typography>



</Box>

      {/* Banner Message */}
      <Snackbar
        open={banner.open}
        autoHideDuration={4000}
        onClose={() => setBanner({ ...banner, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setBanner({ ...banner, open: false })}
          severity={banner.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {banner.message}
        </Alert>
      </Snackbar>

    </>
  );
};

  /* ================= UI ================= */

  return (
    <>
      <HeaderMenu />

      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(to bottom, #f4f7fb, #eef2f7)',
          py: 5,
        }}
      >
        <Box sx={{ maxWidth: 1200, mx: 'auto', px: 3 }}>
          {/* Header */}
          <Paper
			  elevation={0}
			  sx={{
				px: 4,
				py: 1.5, // 🔥 reduced vertical height
				mb: 3,
				borderRadius: 3,
				background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
				color: 'white',
				boxShadow: '0 6px 18px rgba(25,118,210,0.25)',
			  }}
			>
			  <Stack direction="row" alignItems="center" spacing={2}>
				<Typography variant="h6" fontWeight={700}>
				  🏨 Daily Property Expense Entry
				</Typography>
			  </Stack>

			  
			</Paper>
{errorMsg && (
  <Alert
    severity="error"
    sx={{ mb: 2 }}
    onClose={() => setErrorMsg("")}
  >
    {errorMsg}
  </Alert>
)}
          {/* Filter */}
          <Paper
            sx={{
              p: 4,
              mb: 4,
              borderRadius: 4,
              background: '#ffffff',
              boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            }}
          >
            <Typography fontWeight={600} mb={3}>
              🔍 Filter Expenses
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Property Name</InputLabel>
                  <Select
                    value={pendingHostelFilter}
                  onChange={(e) => {
  setPendingHostelFilter(e.target.value);
  setSearchTriggered(false);
  setErrorMsg(""); // ✅ clear
}}
                    label="Property Name"
                  >
                    <MenuItem value="">All</MenuItem>
                    {hostelList.map((h) => (
                      <MenuItem key={h.id} value={h.hostelName}>
                        {h.hostelName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  type="month"
                  fullWidth
                  label="Expense Month"
                  InputLabelProps={{ shrink: true }}
                  value={filter.month}
                  onChange={(e) => {
  setFilter({ month: e.target.value });
  setSearchTriggered(false);
  setErrorMsg(""); // ✅ clear
}}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    sx={{ px: 4, borderRadius: 3 }}
                   onClick={() => {
  if (!pendingHostelFilter && !filter.month) {
    setErrorMsg("Please select Hostel and Month");
    return;
  }

  if (!pendingHostelFilter) {
    setErrorMsg("Please select Hostel");
    return;
  }

  if (!filter.month) {
    setErrorMsg("Please select Month");
    return;
  }

  setErrorMsg(""); // ✅ clear error
  setSearchTriggered(true);
  handleSearch();
}}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{ px: 4, borderRadius: 3 }}
                    onClick={() => {
  setPendingHostelFilter('');
  setFilter({ month: '' });
  setDataLoaded(false);
  setErrorMsg(""); // ✅ ADD THIS

  setData({
    purchase: [],
    staff: [],
    maintenance: [],
    misc: [],
  });
}}
                  >
                    Reset
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Paper>

          {/* Tabs */}
        <Paper sx={{ p: 3, borderRadius: 4 }}>
  <Tabs
    value={tab}
    onChange={(e, v) => setTab(v)}
    variant={isMobile ? "scrollable" : "standard"}
    scrollButtons="auto"
    allowScrollButtonsMobile
    sx={{
      '& .MuiTabs-indicator': { display: 'none' }
    }}
  >
    {[
      { label: 'Purchase', icon: <ShoppingCartIcon /> },
      { label: 'Staff', icon: <PeopleIcon /> },
      { label: 'Maintenance', icon: <BuildIcon /> },
      { label: 'Misc', icon: <CategoryIcon /> },
    ].map((item, i) => (
      <Tab
        key={i}
        icon={item.icon}
        iconPosition="start"
        label={item.label}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 3,
          px: 3,
          mr: 2,
          minWidth: 120,
          '&.Mui-selected': {
            backgroundColor: '#e3f2fd',
            color: '#1976d2',
          },
        }}
      />
    ))}
  </Tabs>

            <TabPanel value={tab} index={0}>
              {renderRows('purchase', 'Shop Name', true)}
            </TabPanel>
            <TabPanel value={tab} index={1}>
              {renderRows('staff', 'Staff Name', false)}
            </TabPanel>
            <TabPanel value={tab} index={2}>
              {renderRows('maintenance', 'Vendor Name', false)}
            </TabPanel>
            <TabPanel value={tab} index={3}>
              {renderRows('misc', 'Expense Name', false)}
            </TabPanel>
          </Paper>
        </Box>
      </Box>
	  <Dialog
  open={deleteConfirm.open}
  onClose={() =>
    setDeleteConfirm({ open: false, type: "", index: null })
  }
>
  <DialogTitle>Confirm Delete</DialogTitle>

  <DialogContent>
    <Typography>
      Are you sure you want to delete this expense item?
    </Typography>

    <Typography sx={{ mt: 1 }} color="text.secondary">
      This action cannot be undone.
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() =>
        setDeleteConfirm({ open: false, type: "", index: null })
      }
    >
      Cancel
    </Button>

    <Button
      color="error"
      variant="contained"
      onClick={async () => {
        await handleDeleteRow(
          deleteConfirm.type,
          deleteConfirm.index
        );
        setDeleteConfirm({ open: false, type: "", index: null });
      }}
    >
      Delete
    </Button>
  </DialogActions>
</Dialog>
    </>
  );
};

export default DailyHostelExpense;